import axios from 'axios'
import { instanceOEF, segundaVersaoOEF } from './api'
import { transformarRespostaEmCamel } from '../utils/formatter/formatter'

export const getPix = idAssinatura => instanceOEF.post( `${segundaVersaoOEF}/gerar-pix`, { 'assinatura_id': idAssinatura }, {
  'transformResponse': axios.defaults.transformResponse.concat( dados => transformarRespostaEmCamel( dados ) )
} )
